{
  "loading": "Laden...",
  "placeholder": "Selecteren…"
}
